import { render, staticRenderFns } from "./TedsLauncherProfileSection.vue?vue&type=template&id=05b5cd71&"
import script from "./TedsLauncherProfileSection.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherProfileSection.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherProfileSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports